import { render, staticRenderFns } from "./PDFSellerDetail.vue?vue&type=template&id=31827b64"
import script from "./PDFSellerDetail.vue?vue&type=script&lang=js"
export * from "./PDFSellerDetail.vue?vue&type=script&lang=js"
import style0 from "./PDFSellerDetail.vue?vue&type=style&index=0&id=31827b64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports